import a, { useState as T, useRef as s, useEffect as j } from "react";
import { ArrowButton as I } from "../ArrowButton/ArrowButton.js";
import { MediaCounter as z } from "../MediaCounter/MediaCounter.js";
import { Text as G } from "../Text/Text.js";
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const U = "https://static.olx.com.br/cd/listing/notFound.png",
  k = _ref => {
    let {
      imageList: t = [],
      isCarrouselDisabled: d = !1,
      totalCarouselImages: D = 0,
      totalCarouselVideos: g,
      badge: A,
      isSmallScreen: i,
      showDisabledButton: _,
      loading: B = "lazy",
      displayMoreContentOverlay: p,
      previousImageHandler: E,
      nextImageHandler: x,
      imgOptimization: o,
      showImageBlurBackground: b
    } = _ref;
    const [r, O] = T(0),
      c = s([0]),
      h = s(null),
      v = s(null),
      C = s(null),
      f = s(null);
    !t.length && t.push({
      url: U,
      alt: "An\xFAncio sem imagens"
    });
    const N = r === 0,
      m = r === t.length - 1,
      $ = !d && (!N || _),
      F = !d && (!m || _),
      y = i && g ? 0 : D,
      u = y - t.length + 1,
      R = (l, e) => l ? e + 1 : e - 1,
      w = l => {
        const e = R(l, r);
        c.current.push(e), O(e), l ? x == null || x(e, c.current) : E == null || E(e, c.current);
      },
      W = () => {
        w(!1);
      },
      M = () => {
        w(!0);
      },
      V = () => {
        var l, e, n;
        const L = (e = (l = C.current) == null ? void 0 : l.clientWidth) != null ? e : 0,
          P = r;
        (n = f.current) == null || n.scrollTo({
          top: 0,
          left: L * P,
          behavior: "smooth"
        });
      },
      S = l => {
        const e = l.current;
        e != null && e.dataset.src && (e.src = e.dataset.src, e.dataset.src = "");
      };
    j(() => {
      !o && S(h), !o && S(v), !o && V();
    });
    const H = (l, e) => {
      if (e !== r && o) return null;
      let n = null;
      return e === r && !o && (n = h), e === r + 1 && !o && (n = v), a.createElement("li", {
        className: "olx-image-carousel__item ".concat(e !== 0 ? "olx-image-carousel__item-next" : ""),
        key: "".concat(l.alt).concat(e)
      }, b && a.createElement("div", {
        className: "olx-image-carousel__blur",
        style: {
          backgroundImage: "url(".concat(l.url, ")")
        }
      }), a.createElement("picture", {
        className: b ? "olx-image-carousel__blur-image" : ""
      }, a.createElement("source", {
        srcSet: l.urlWebP,
        type: "image/webp"
      }), a.createElement("source", {
        srcSet: l.url,
        type: "image/jpeg"
      }), a.createElement("img", {
        ref: n,
        alt: l.alt,
        loading: B,
        src: l.url
      })));
    };
    return a.createElement("div", {
      ref: C,
      className: "olx-image-carousel",
      "data-ds-component": "DS-ImageCarousel"
    }, a.createElement("ul", {
      className: "olx-image-carousel__items",
      ref: f
    }, t.map(H)), p && t.length > 1 && u > 0 && a.createElement("div", {
      className: "olx-image-carousel__content-overlay ".concat(p && m && u > 0 && t.length > 1 ? "olx-image-carousel__content-overlay--active" : ""),
      "aria-hidden": !0,
      "data-testid": "image-carousel-overlay"
    }, a.createElement(G.DisplayMedium, {
      color: "--color-neutral-70"
    }, "+", u)), A, !i && a.createElement(a.Fragment, null, $ && a.createElement("div", {
      className: "olx-image-carousel__left-button"
    }, a.createElement(I, {
      onClick: W,
      disabled: N,
      "aria-label": "Imagem anterior",
      expandClickableArea: !0
    })), F && a.createElement("div", {
      className: "olx-image-carousel__right-button"
    }, a.createElement(I, {
      direction: "right",
      onClick: M,
      disabled: m,
      "aria-label": "Pr\xF3xima imagem",
      expandClickableArea: !0
    }))), a.createElement("div", {
      className: "olx-image-carousel__counter-wrapper"
    }, a.createElement(z, {
      imagesCount: y,
      videosCount: g,
      hideNumbers: i
    })));
  };
k.displayName = "ImageCarousel";
export { k as ImageCarousel };